import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTankCarTankWagon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 126.67,
	height: 80,
	viewBox: "0 0 126.67 80.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 13.33 60.0 A 50.0 50.0 0.0 0 1 13.33 0.0 L 113.33 0.0 A 50.0 50.0 0.0 0 1 113.33 60.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 28.33,
			cy: 70,
			rx: 10,
			ry: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 98.33,
			cy: 70,
			rx: 10,
			ry: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgTankCarTankWagon;
